import React from "react";

const Footer = () => (
  <footer className="text-center fixed-bottom p-3">
    <small>
      Made with{" "}
      <span className="text-danger fas fa-heart" aria-hidden="true"></span>
      <span className="sr-only">love</span> by{" "}
      <a
        href="https://github.com/davidoluseun"
        target="_blank"
        rel="noopener noreferrer"
      >
        AOD
      </a>
    </small>
  </footer>
);

export default Footer;
